export const CLIENT = 'client';
export const SERVER = 'server';
export const ASC_SORT_DIRECTION = 'asc';
export const DESC_SORT_DIRECTION = 'desc';
export const NO_SORT_DIRECTION = null;
export const SCROLL_AMOUNT = 177;
